var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideoPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Play-List-4--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Play List 4 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-list-4--screen-television-display-player-movies-players-tv-media-video-entertainment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#e1c330",
    d: "M12.0769 1H1.92308C1.41328 1 1 1.41328 1 1.92308V12.0769c0 0.5098 0.41328 0.9231 0.92308 0.9231H12.0769c0.5098 0 0.9231 -0.4133 0.9231 -0.9231V1.92308C13 1.41328 12.5867 1 12.0769 1Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M1.92308 1.625c-0.16463 0 -0.29808 0.13345 -0.29808 0.29808V12.0769c0 0.1646 0.13345 0.2981 0.29808 0.2981H12.0769c0.1646 0 0.2981 -0.1335 0.2981 -0.2981V1.92308c0 -0.16463 -0.1335 -0.29808 -0.2981 -0.29808H1.92308ZM0.375 1.92308C0.375 1.0681 1.0681 0.375 1.92308 0.375H12.0769c0.855 0 1.5481 0.6931 1.5481 1.54808V12.0769c0 0.855 -0.6931 1.5481 -1.5481 1.5481H1.92308C1.0681 13.625 0.375 12.9319 0.375 12.0769V1.92308Zm4.85498 7.30698h-0.5v-4.3226h0.00001c0.00083 -0.16043 0.04406 -0.31778 0.12531 -0.45611 0.08125 -0.13834 0.19762 -0.25274 0.33732 -0.3316 0.13971 -0.07887 0.29778 -0.1194 0.4582 -0.11749 0.15929 0.0019 0.31526 0.04558 0.45234 0.12664l3.69697 2.14824 0.00066 0.00038c0.13797 0.07987 0.25251 0.1946 0.33221 0.33268 0.0798 0.1383 0.1219 0.29518 0.1219 0.45486 0 0.15969 -0.0421 0.31656 -0.1219 0.45487 -0.0796 0.13793 -0.19398 0.25254 -0.33174 0.33241l-0.00113 0.00065 -3.69644 2.15791c-0.13721 0.0813 -0.29338 0.1251 -0.45287 0.127 -0.16042 0.0019 -0.31849 -0.0387 -0.4582 -0.1175 -0.1397 -0.07889 -0.25607 -0.19328 -0.33732 -0.33162 -0.08125 -0.13833 -0.12448 -0.29569 -0.12531 -0.45611l0.49999 -0.00261Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoPreviewIcon);
export default __webpack_public_path__ + "static/media/play-video-preview-icon.5b2c4f0bd488364898280649dcb441d9.svg";
export { ForwardRef as ReactComponent };